module.exports = __webpack_public_path__ + "static/img/can-strawberry-sunset.9aaeb9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-strawberry-sunset.png
// module id = Wj/9
// module chunks = 0